




























import {
  computed,
  defineComponent,
  PropType,
  ref,
  toRefs,
  useFetch,
  useRouter,
  watch
} from '@nuxtjs/composition-api'
import { useDeps } from '~/compositions/dependency-container'
import AuditShopService from '~/services/audits/AuditShopService'
import { Option } from '~/models/shared/types'
import { AuditProviderShop } from '~/models/audit/shop'
import CEmptyState from '~/components/shared/configurable/CEmptyState.vue'
import { ciAuditShop } from '~/icons/source/regular/audit-shop'

export default defineComponent({
  components: { CEmptyState },
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      default() {
        return this.$t('audit shop')
      }
    },
    placeholder: {
      type: String,
      default() {
        return this.$t('all audit shops')
      }
    },
    excludeShop: {
      type: Number as PropType<AuditProviderShop['id']>,
      required: false
    },
    inModal: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props, { emit }) {
    const { value, excludeShop } = toRefs(props)

    const auditShopsOptions = ref<Option[]>([])
    const loading = ref(false)
    const internalValue = ref(value.value)
    const [auditShopService] = useDeps(AuditShopService)
    const router = useRouter()

    useFetch(async () => {
      loading.value = true
      const { shops } = await auditShopService.getShops()
      auditShopsOptions.value = shops
        .map(s => ({
          text: s.auditShop.displayName,
          value: s.auditShop.id
        }))
        .filter(s => s.value !== excludeShop.value)
      loading.value = false
    })

    watch(value, newValue => (internalValue.value = newValue))

    function handleChange(val: any) {
      emit('change', val)
      emit('input', val)
    }

    const newShopUrl = computed(
      () => router.resolve({ name: '__account_audits_shops_new' }).href
    )

    return {
      auditShopsOptions,
      handleChange,
      internalValue,
      loading,
      ciAuditShop,
      newShopUrl
    }
  }
})
